import { DraftReport } from "src/entities/draftReport/ui";

export function DraftReportPage() {
  return <DraftReport />;
}
